import axios from "axios";

const service = axios.create({
    withCredentials: true
})
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem("access_token") || ""
        const user_id = localStorage.getItem("user_id") || ""
        config.headers['x-token'] = token;
        config.headers['Authorization'] = token;
        config.headers['x-user-id'] = user_id;
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code && res.code !== 0) {
            return Promise.resolve(res || 'error')
        } else {
            return Promise.resolve(res)
        }
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)
service.defaults.withCredentials = false

const dataURLtoFileFun = (dataurl, filename) => {
    let arr = dataurl.content.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
}

export const uploads =(content,callback)=> {
    let formData = new FormData()
    let fileReplace = content.file.type.replace(/\//g, '.')
    formData.append('file', dataURLtoFileFun(content, fileReplace ))
    return service({
        url: 'https://byh-api.dr-gobroad.com/course/upload/file',
        method: 'post',
        data:formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function(res){
            callback(res)
        }
    })
}



// WEBPACK FOOTER //
// ./src/util/upload.js